import type { DataType } from '@/graphql/types';
import { FrequencyGraphScaleType } from '@/graphql/types';
import { SwarmType } from '../enums';
import type { AssertEqual } from '../utils/types';

// These values need to match with backend/sbr/enums.py:DataTab.
// The keys need to match the DataType GraphQL type.
export enum DATA_TYPE {
    VTOP = 'vtop',
    ATOP = 'atop',
    FDOM = 'fdom',
    VEFF = 'veff',
    VDV = 'vdv',
    PM10 = 'PM10',
    PM2P5 = 'PM2p5',
    FLOW = 'flow',
    RH = 'relativeHumidity',
    TEMP = 'temperature',
    LXN = 'lXn',
    LXEQ = 'lXEq',
    LXTMAX = 'lXtMax',
    LXPEAK = 'lXPeak',
    DAILY_VALUES = 'dailyValues',
    LDEN = 'lden',
}

export type DataTypeValue = `${DATA_TYPE}`;

/**
 * Type assertion to ensure that all possible DataType values are covered in the DATA_TYPE enum.
 *
 * This assertion will cause a TypeScript error if there are any DataType values not represented.
 * If this happens verify that the DATA_TYPE enum includes all necessary entries from the
 * DataType type in the GraphQL schema.
 */
// eslint-disable-next-line no-underscore-dangle
const _assertDataType: AssertEqual<`${DataType}`, keyof typeof DATA_TYPE> = true;

export const DefaultDataType = Object.freeze({
    [SwarmType.Vibration]: DATA_TYPE.VTOP,
    [SwarmType.Air]: DATA_TYPE.PM10,
    [SwarmType.Sound]: DATA_TYPE.LXEQ,
});

// Re-exporting for backward compatibility
export { FrequencyGraphScaleType as ScaleType };
